import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CoordinationPage } from '@/features/design/coordination-page';

const searchSchema = z.object({
  item: z.string().optional().catch(undefined),
  view: z.enum(['list', 'ageing']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/design/coordination')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <CoordinationPage projectId={projectId} itemId={search.item} view={search.view ?? 'list'} />
  );
}
